import { render, staticRenderFns } from "./reclaim-by-id.vue?vue&type=template&id=2cfcbcbe&"
import script from "./reclaim-by-id.vue?vue&type=script&lang=js&"
export * from "./reclaim-by-id.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports